var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgManBuy = function SvgManBuy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 90,
    viewBox: "0 0 57 90",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    transform: "translate(-15 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EDC3B4",
    d: "M34.59 50.712a5.16 5.16 0 0 0 5.16-5.16v-5a5.16 5.16 0 0 0-10.32.01v5a5.16 5.16 0 0 0 5.16 5.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424243",
    d: "M34.59 50.952a5.42 5.42 0 0 1-5.41-5.41v-5a5.41 5.41 0 0 1 10.82 0v5a5.42 5.42 0 0 1-5.41 5.41zm0-15.31a4.92 4.92 0 0 0-4.91 4.91v5a4.915 4.915 0 0 0 9.83 0v-5a4.92 4.92 0 0 0-4.92-4.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M71.39 55.452a3.761 3.761 0 0 0-7.52.19s0 3.93-2.1 6.06a5.68 5.68 0 0 1-4.27 1.51c-2.17 0-4.31-.66-5.25-5.46l-.16-.81a20.8 20.8 0 0 0-1.1-4.72 15 15 0 0 0-9.33-8.6 37.9 37.9 0 0 0-1.72-.37v-1.13H28.67v1.15c-1.08.19-1.71.35-1.71.35h-.06a17.44 17.44 0 0 0-9 6.69 14.51 14.51 0 0 0-1.83 7.49c-.15 4.08-.34 8.26-.31 12.35a3.62 3.62 0 0 0 3 3.46 36.23 36.23 0 0 0 4.61.56v14.1H46.3v-24.79a11.49 11.49 0 0 0 11.25 7.25 13 13 0 0 0 9.67-3.79c4.31-4.47 4.18-11.2 4.17-11.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424243",
    d: "M46.24 88.802H23.32a.5.5 0 0 1-.5-.5v-13.67h-.32a21.36 21.36 0 0 1-3.93-.5c-2.2-.67-3.33-2-3.34-3.93 0-3.5.11-7.11.24-10.59 0-.594.023-1.187.07-1.78a15 15 0 0 1 1.91-7.74 17.82 17.82 0 0 1 9.29-6.89h.05s.5-.13 1.34-.29v-.74a.5.5 0 0 1 .5-.5h11.3a.5.5 0 0 1 .5.5v.73c.47.09.91.19 1.34.3 4.67 1.66 8.18 4.91 9.63 8.9a21.44 21.44 0 0 1 1.11 4.72v.08l.16.81c.91 4.66 2.93 5.06 4.76 5.06a5.21 5.21 0 0 0 3.92-1.36c1.91-1.94 2-5.56 2-5.71a4.26 4.26 0 1 1 8.51-.2c0 .3.14 7.23-4.36 11.84a13.43 13.43 0 0 1-10 3.94c-4.81 0-8.42-1.93-10.76-5.73v22.75a.5.5 0 0 1-.5.5zm-22.43-1h21.93v-24.32a.51.51 0 0 1 1-.2 11 11 0 0 0 10.8 7 12.48 12.48 0 0 0 9.31-3.64c4.22-4.32 4.09-10.85 4.08-11.12a3.261 3.261 0 1 0-6.52.17c0 .42-.09 4.21-2.25 6.4a6.14 6.14 0 0 1-4.63 1.66c-2.27 0-4.73-.7-5.74-5.86l-.13-.69a.46.46 0 0 1 0-.15 20.39 20.39 0 0 0-1.15-4.65 14.44 14.44 0 0 0-9-8.29c-.53-.13-1.07-.25-1.66-.35a.5.5 0 0 1-.41-.49v-.64H29.16v.65a.5.5 0 0 1-.41.49c-.95.16-1.55.31-1.65.34a16.83 16.83 0 0 0-8.78 6.49 14.09 14.09 0 0 0-1.75 7.23c0 .593-.023 1.186-.07 1.78-.13 3.47-.27 7.06-.24 10.54 0 2 1.51 2.64 2.63 3a21.25 21.25 0 0 0 3.71.46h.58c.2 0 .67.06.67.53l-.04 13.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404041",
    d: "M45.57 93.241H23.03v-6.27h22.54z",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDC3B4",
    d: "M47.83 33.462c-.16 4.56-5.71 8.08-12.38 8h-.23c-6.62-.12-12.09-3.8-12.25-8.32l-.62-17.55c-.18-5.11 5.54-9.33 12.83-9.31h.26c7.34 0 13.18 4.33 13 9.49l-.61 17.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3D3C5",
    d: "M37.86 6.402l-.1 34.91c5.59-.61 9.93-3.82 10.07-7.85l.61-17.74c.15-4.57-4.41-8.48-10.58-9.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424243",
    d: "M35.5 41.602h-.27a16.18 16.18 0 0 1-8.64-2.54c-2.37-1.6-3.73-3.71-3.81-6l-.63-17.55c-.19-5.21 5.63-9.54 13-9.54h.3a16.17 16.17 0 0 1 9.5 2.89c2.51 1.85 3.84 4.28 3.75 6.83l-.62 17.74c-.17 4.68-5.82 8.28-12.58 8.17zm-.36-35.15c-7.12 0-12.72 4.12-12.55 9.09l.61 17.55c.07 2.14 1.37 4.15 3.63 5.68a15.65 15.65 0 0 0 8.4 2.45h.27c6.51.1 12-3.33 12.1-7.77l.59-17.74a7.79 7.79 0 0 0-3.6-6.47 15.64 15.64 0 0 0-9.18-2.79h-.3.03z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.98,
    cy: 27.062,
    fill: "#C27E77",
    rx: 2.29,
    ry: 1.97
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.27,
    cy: 27.062,
    fill: "#C27E77",
    rx: 2.29,
    ry: 1.97
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424243",
    d: "M38.08 28.262a1.36 1.36 0 0 1-.88-.31.24.24 0 1 1 .31-.36 1 1 0 0 0 1 .07.92.92 0 0 0 .46-.88 1.21 1.21 0 0 0-.62-.87 1.6 1.6 0 0 0-.5-.19h-.19v-1.79a.24.24 0 0 1 .48 0v1.37c.16.044.315.108.46.19.465.254.78.714.85 1.24a1.4 1.4 0 0 1-.7 1.34 1.46 1.46 0 0 1-.67.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDC3B4",
    d: "M23.32 21.842s-3.84 0-3.84 3 3.83 3 3.83 3l.01-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424243",
    d: "M22.01 27.302a2.92 2.92 0 0 1-1.54-.68 2.28 2.28 0 0 1-.66-1.72 2.51 2.51 0 0 1 1.88-2.5 4 4 0 0 1 .57-.07.51.51 0 0 0 .49-.36 1.43 1.43 0 0 0 0-.47.28.28 0 0 0 0-.15c-.13-.2-.81 0-1 .07a4.5 4.5 0 0 0-.86.27 3.29 3.29 0 0 0-2.11 3.24 3.18 3.18 0 0 0 1 2.41 4.26 4.26 0 0 0 2.73 1c.28 0 .53.15.52-.12v-.38a.51.51 0 0 0-.49-.49l-.53-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBA999",
    d: "M22.47 22.972c-1 0-1.81.81-1.81 1.81a1.72 1.72 0 0 0 1.8 1.74l.01-3.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424243",
    d: "M40.01 4.742a12.4 12.4 0 0 1 3.31 1.73 20.8 20.8 0 0 1 4.14 3.44c.456.61.867 1.25 1.23 1.92l2.09 3.63a2.88 2.88 0 0 1 .53 2.51c-1.59 3.49-9.48.73-11.66-.57-.95-.56-1.27-1.21-2.24-.67a6.55 6.55 0 0 1-4.23.71 6.7 6.7 0 0 1-3.14-1.49 7.15 7.15 0 0 1-2.15-2.29 20.9 20.9 0 0 1-2 4.93c-.65 1.12-2.38 3.73-3.84 3.73-.11-.45-.29-.89-.38-1.35-.09-.46-.12-1.23-.22-1.84a16.93 16.93 0 0 1 .72-7.87 6.66 6.66 0 0 1 1.59-2.86 3.16 3.16 0 0 1 1.73-.87c.66-.09 1.08.2 1.62-.15s.94-1.13 1.5-1.53a7.64 7.64 0 0 1 1.93-1 14.49 14.49 0 0 1 9.47-.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404041",
    d: "M41.37 29.102h-7.21a2.14 2.14 0 0 0-2.14 2.14v8.05a2.14 2.14 0 0 0 2.14 2.11h7.21a2.14 2.14 0 0 0 2.14-2.14v-8.02a2.14 2.14 0 0 0-2.14-2.14zm.38 6a2.14 2.14 0 0 1-2.16 2.12h-3.7a2.14 2.14 0 0 1-2.14-2.14v-1.18a2.14 2.14 0 0 1 2.14-2.14h3.7a2.14 2.14 0 0 1 2.14 2.14l.02 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M27.7 58.572l-7.36 15.34s6.42.86 14.09-8.85l-6.73-6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424243",
    d: "M20.79 74.402a4.13 4.13 0 0 1-.52 0 .504.504 0 0 1 .13-1c.07 0 6.12.64 13.36-8.31l-6.41-6.18a.5.5 0 0 1 .69-.72l6.73 6.5a.5.5 0 0 1 0 .67c-6.55 8.37-12.26 9.04-13.98 9.04zM22.3 62.402a.5.5 0 0 1-.5-.5v-8.58a.5.5 0 1 1 1 0v8.61a.5.5 0 0 1-.5.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424243",
    d: "M23.79 62.742a.5.5 0 0 1-.3-.89 40.45 40.45 0 0 0 3.36-2.75.5.5 0 0 1 .94 0c.13.38.19.57-3.69 3.53a.5.5 0 0 1-.31.11z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.48,
    cy: 62.442,
    fill: "#F3D3C5",
    rx: 6.38,
    ry: 6.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDC3B4",
    d: "M30.71 66.922a6.47 6.47 0 0 0 5.35-10.07 6.45 6.45 0 1 1-9.13 8.82 6.38 6.38 0 0 0 3.78 1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424243",
    d: "M25.59 62.402a6.9 6.9 0 1 1 6.9 6.69 6.81 6.81 0 0 1-6.9-6.69zm1 0a5.87 5.87 0 1 0 5.87-5.66 5.78 5.78 0 0 0-5.87 5.66z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.763,
    cy: 22.794,
    r: 1,
    fill: "#424243",
    transform: "rotate(-.16 44.763 22.794)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.463,
    cy: 22.799,
    r: 1,
    fill: "#424243",
    transform: "rotate(-.16 32.463 22.799)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424243",
    d: "M41.27 20.822a.47.47 0 0 1 .49-.45h4a.45.45 0 0 1 0 .9h-4a.47.47 0 0 1-.49-.45zM30.05 20.402a4.77 4.77 0 0 1 4.74 0 .47.47 0 0 1 .27.63.49.49 0 0 1-.64.16 4 4 0 0 0-4 0 .49.49 0 0 1-.64-.16.47.47 0 0 1 .27-.63z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 18,
    x: 55.52,
    y: 42.952,
    fill: "#AD5151",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 17,
    x: 56,
    y: 43.78,
    fill: "#262626",
    opacity: 0.68,
    rx: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.61,
    height: 3.48,
    x: 59,
    y: 46,
    fill: "#262626",
    rx: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.49,
    cy: 54.972,
    fill: "#F3D3C5",
    rx: 5.85,
    ry: 5.66
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDC3B4",
    d: "M63.87 59.072a5.93 5.93 0 0 0 4.9-9.23 5.91 5.91 0 1 1-8.37 8.09 5.85 5.85 0 0 0 3.47 1.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424243",
    d: "M59.17 54.972a6.33 6.33 0 1 1 6.32 6.14 6.24 6.24 0 0 1-6.32-6.14zm.94 0a5.38 5.38 0 1 0 5.38-5.19 5.29 5.29 0 0 0-5.38 5.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M36.18 33.262v1.36a1.93 1.93 0 0 0 3.74 0v-1.36h-3.74z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManBuy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/man-buy.7eae0d4e.svg";
export { ForwardRef as ReactComponent };